// Strings copied verbatim from mcp/Coaching notes + your AI · Mento prototype.html.
import type { CoachingNoteListCategory } from '@/store/api/mcpMemberApi';

export type SettingsPageId = 'coaching-notes' | 'connect-ai' | 'ai-moments';

export const SETTINGS_PAGES: ReadonlyArray<{
  icon: string;
  id: SettingsPageId;
  label: string;
}> = [
  { icon: 'note', id: 'coaching-notes', label: 'Coaching notes' },
  { icon: 'public_link', id: 'connect-ai', label: 'Connect your AI' },
  {
    icon: 'tips_and_updates',
    id: 'ai-moments',
    label: 'When your AI brings this up',
  },
];

export const settingsLabel = (id: SettingsPageId): string =>
  SETTINGS_PAGES.find((page) => page.id === id)?.label ?? '';

export const NOTE_CATEGORIES: readonly CoachingNoteListCategory[] = [
  'realized',
  'strengths',
  'opportunities',
  'guidance',
  'actions',
];

export const categoryMeta = (
  category: CoachingNoteListCategory,
  coachFirstName: string,
): { description: string; name: string } => {
  switch (category) {
    case 'realized':
      return {
        description: 'What came into focus for you across sessions',
        name: 'What You Realized',
      };
    case 'strengths':
      return {
        description:
          'What you’re already doing well, as it showed up in sessions',
        name: 'Strengths',
      };
    case 'opportunities':
      return {
        description: 'Openings in your current work',
        name: 'Leadership Opportunities',
      };
    case 'guidance':
      // NEW COPY fallback "your coach" when the coach name is missing.
      return {
        description: `Advice from ${coachFirstName || 'your coach'} worth coming back to`,
        name: 'Coach Guidance',
      };
    case 'actions':
      return { description: 'What you said you’d try', name: 'Action Items' };
    default:
      return { description: '', name: '' };
  }
};

export const NOTES_GROUPS = {
  notes: 'From your reflections',
  people: 'People',
} as const;
